import React from "react";
import { AccordionRowWrapper } from "./AccordionRow.styles";
import AccordionItem from "./AccordionItem";
import { backgroundColourFormatter } from "../Global/utils/flexipageHelpers";
import BardCopy from "../Global/BardCopy/BardCopy";

const AccordionRow = ({data}) => {

    const copy = data.copy;
    const accordionsArray = data.accordion_items;
    const accordionsMarkup = [];
    const bgColor = backgroundColourFormatter(data.background_colour?.value);
    const prevWidgetClass = data.addClassToPrevious ? data.addClassToPrevious : '';

    if (accordionsArray) {
        accordionsArray.forEach((accordionItem, idx) => {
            accordionsMarkup.push(<AccordionItem key={idx} data={accordionItem}/>)
        });
    }

    return(
        <AccordionRowWrapper id={data.row_id} className={`flexipage-row ${bgColor}${prevWidgetClass}`} data-animation-trigger="true">
            <div className="flexipage-container" data-animation="animate__fadeIn" data-animation-duration="1s" data-animation-delay="0.1s">
                <BardCopy nodes={copy} className="accordion-row-copy" />
                {accordionsMarkup}
            </div>
        </AccordionRowWrapper>
    )
}

export default AccordionRow;
